(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shineon-romantic-configurator"] && !Shopify.designMode) return;
  try {
    (() => {
    const labels = {
      title: 'Farbe auswählen ✨',
      engraving: 'Gravur auf der Rückseite 💌',
      silver: 'Silberfarben',
      gold: 'Goldfarben',
      no: 'Ohne Gravur',
      yes: 'Mit Gravur',
      line1: 'Gravur – Zeile 1',
      line2: 'Gravur – Zeile 2',
      placeholder: 'Deine Worte hier',
      upload: 'Foto auswählen',
      change: 'Foto ändern',
      confirm: 'Vorschau bestätigen',
      confirmed: 'Vorschau bestätigt',
      edit: 'Vorschau bearbeiten',
      hint: 'Am schönsten wirkt ein helles, scharfes Foto mit dem Motiv in der Mitte.'
    };

    const setText = (element, value) => {
      if (element && element.textContent.trim() !== value) element.textContent = value;
    };

    const localizeVariants = (variantSelects) => {
      const fieldsets = [...variantSelects.querySelectorAll('fieldset')];
      fieldsets.forEach((fieldset, index) => {
        setText(fieldset.querySelector('legend'), index === 0 ? labels.title : labels.engraving);
        [...fieldset.querySelectorAll('input[type="radio"]')].forEach((input) => {
          const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (!label) return;
          const hidden = label.querySelector('.visually-hidden');
          const translated = input.value.includes('Silver') ? labels.silver
            : input.value.includes('Gold') ? labels.gold
            : input.value === 'Yes' ? labels.yes
            : input.value === 'No' ? labels.no
            : input.value;
          const textNodes = [...label.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE);
          const currentText = textNodes.map((node) => node.textContent).join(' ').trim();
          if (currentText !== translated) {
            textNodes.forEach((node) => node.remove());
            label.insertBefore(document.createTextNode(translated), hidden || null);
          }
          label.classList.toggle('shineon-value-silver', input.value.includes('Silver'));
          label.classList.toggle('shineon-value-gold', input.value.includes('Gold'));
        });
      });
    };

    const localizeShineOn = (shineOn) => {
      [...shineOn.querySelectorAll('.so-form__label')].forEach((label, index) => setText(label, index === 0 ? labels.line1 : labels.line2));
      [...shineOn.querySelectorAll('.so-engraving-input')].forEach((input) => input.placeholder = labels.placeholder);
      [...shineOn.querySelectorAll('.upload-status')].forEach((status) => {
        const current = status.textContent.trim().toLowerCase();
        if (current.includes('confirm')) setText(status, labels.confirm);
        else if (current.includes('change') || current.includes('replace')) setText(status, labels.change);
        else if (current.includes('upload') || current.includes('image')) setText(status, labels.upload);
      });
      [...shineOn.querySelectorAll('button span')].forEach((status) => {
        const current = status.textContent.trim().toLowerCase();
        if (current.includes('confirm design')) setText(status, labels.confirm);
        else if (current.includes('confirmed')) setText(status, labels.confirmed);
        else if (current.includes('edit design')) setText(status, labels.edit);
      });
      const controls = shineOn.querySelector('.upload-controls');
      if (controls && !controls.querySelector('.shineon-romance-upload-hint')) {
        const hint = document.createElement('p');
        hint.className = 'shineon-romance-upload-hint';
        hint.textContent = labels.hint;
        controls.append(hint);
      }
    };

    const initialize = () => {
      const intro = document.querySelector('.shineon-romance-ui');
      const productInfo = intro?.closest('body')?.querySelector('product-info');
      const variantSelects = productInfo?.querySelector('variant-selects');
      const shineOn = productInfo?.querySelector('.so-hyper-fields');
      if (!intro || !productInfo || !variantSelects || !shineOn) return;
      productInfo.classList.add('shineon-romance-product');
      if (intro.parentElement !== productInfo.querySelector('.product__info-container')) variantSelects.before(intro);
      intro.hidden = false;
      localizeVariants(variantSelects);
      localizeShineOn(shineOn);
      if (!productInfo.dataset.romanceObserver) {
        productInfo.dataset.romanceObserver = 'true';
        const localizeCurrentFields = () => {
          const currentVariants = productInfo.querySelector('variant-selects');
          const currentShineOn = productInfo.querySelector('.so-hyper-fields');
          if (currentVariants) localizeVariants(currentVariants);
          if (currentShineOn) localizeShineOn(currentShineOn);
        };
        new MutationObserver(localizeCurrentFields).observe(productInfo, { childList: true, subtree: true });
        productInfo.addEventListener('change', () => requestAnimationFrame(localizeCurrentFields));
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

})();
